module.exports = __webpack_public_path__ + "img/logo-text.93e1b0e9.png";